export const getFileExtension = (filename: string): string => {
    const lastIndex = filename.lastIndexOf(".");
    if (lastIndex !== -1 && lastIndex !== filename.length - 1) {
        return filename.slice(lastIndex + 1);
    } else {
        return "";
    }
};
